module.exports = __webpack_public_path__ + "static/media/Deep-dive.c8562b46.pdf";